import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const SubscriptionRoutes = defineRoute({
    record: {
        route: {
            path: "/subscription",
            component: () => loadView(import("./SubscriptionTable.vue")),
        },
    },
    create: {
        route: {
            path: "/subscription/create/:id",
            component: () => loadView(import("./SubscriptionCreate.vue")),
        },
        build(id: string) {
            return `/subscription/create/${id}`;
        },
        debug: true,
    },
    update: {
        route: {
            path: "/subscription/update/:id",
            component: () => loadView(import("./SubscriptionUpdate.vue")),
        },
        build(id: string) {
            return `/subscription/update/${id}`;
        },
    },
    radius: {
        route: {
            path: "/subscription/account/:id",
            component: () => loadView(import("./SubscriptionAccount.vue")),
        },
        build(id: string) {
            return `/subscription/account/${id}`;
        },
    },
});
